import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ButtonWithIcon from "components/button/buttonWithIcon";
import React from "react";

const ApplicationBox = ({ data, history }) => {
  const handleViewDetail = (data) => {
    history.push(`/mylead-view/${data.lead_id}`);
  };
  
  return (
    <div className="lead-box-wrap">
      <div className="detail-header">
        <div className="header-view-sub">
          <img src={Images?.user} alt="edit" width={37} />
          <div className="">
            <p className="data-details">
              {localization.formLabel.applicationNo}
            </p>
            <strong className="data-title">{data?.application_no}</strong>
          </div>
        </div>
        <div className="header-view-sub status-section">
          <p className="status text-center in-progress">{data?.status}</p>
          <p className="">{`( ${localization.personalDetail} )`}</p>
        </div>
      </div>
      <div className="detail-description">
        <div className="des-sub">
          <p>{localization.name}</p>
          <strong>{data?.student_name}</strong>
        </div>
        <div className="des-sub">
          <p>{localization.phoneNumber}</p>
          <strong>{data?.phone}</strong>
        </div>
        <div className="des-sub">
          <p>{localization.email}</p>
          <strong>{data?.email}</strong>
        </div>
      </div>
      <div className="btn-wrap">
        <ButtonWithIcon
          title={localization.viewDetails}
          src={Images.arrow}
          className={"secondary-button"}
          onClick={()=>handleViewDetail(data)}
        />
       
      </div>
    </div>
  );
};

export default ApplicationBox;
